<template>
  <main-layout>
    <template slot="header-title">Surveys NPS</template>

    <template slot="header-actions">
      <common-button
        @click="isOpenFormNewSurvey = true">Create a survey</common-button>
    </template>

    <template slot="main">

      <surveys-ui-list />

      <surveys-ui-modal-create  v-if="isOpenFormNewSurvey" :open="isOpenFormNewSurvey" :site="site" @close="closeFormNewSurvey"/>

    </template>
  </main-layout>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'SurveyHome',

  props: {
  },

  data () {
    return {
      isOpenFormNewSurvey: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },

  watch: {
    site: {
      handler: 'initOnBoarding',
      immediate: true
    }
  },

  methods: {
    initOnBoarding () {
    },
    closeFormNewSurvey () {
      this.isOpenFormNewSurvey = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Survey/SurveyList.vue